import { render, staticRenderFns } from "./InternetAccessTab.vue?vue&type=template&id=2be4824f&scoped=true&"
import script from "./InternetAccessTab.vue?vue&type=script&lang=js&"
export * from "./InternetAccessTab.vue?vue&type=script&lang=js&"
import style0 from "./InternetAccessTab.vue?vue&type=style&index=0&id=2be4824f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be4824f",
  null
  
)

export default component.exports